import { Brick, registerBrick, Transaction, CloudObject, BusinessObject, DBView, RelationPrimitive, transformers, Direction } from 'olympe';
import {ChartsData} from "./model/ChartsData";
import {getLogger} from "@olympeio/core";


export default class ObjectToChartsData extends Brick {

    init(context){
        this.logger = getLogger('charts');
        this.db = DBView.get();
    }

    /**
     * @protected
     * @param {!BrickContext} context
     * @param {*} businessObject
     * @param {string} labelPath
     * @param {string} valuePath
     * @param {olympe.df.Color} color
     * @param {function(*)} setData
     */
    update(context, [businessObject, labelPath, valuePath, color], [setData]) {

        if(!(businessObject instanceof CloudObject)){
            this.logger.error('The first parameter is supposed to be a business object');
            return;
        }
        if(labelPath && valuePath && color){
            const properties = new Map();
            properties.set(ChartsData.labelProp, this.extractProp(businessObject, labelPath.split('.')));
            properties.set(ChartsData.numberProp, this.extractProp(businessObject, valuePath.split('.')));
            properties.set(ChartsData.colorProp, color);
            const transaction = new Transaction(false);
            const result = transaction.create(ChartsData, properties);
            transaction.execute().then(() => {
                setData(CloudObject.get(result));
            }).catch((message)=> {
                this.logger.error(`An error were encountered while converting a business object to chart data ${message}`);
            });
        } else {
            this.logger.error('An input is missing');
        }
    }



    /**
     *
     * @param {CloudObject} object
     * @param {Array} path
     */
    extractProp(object, path){

        if(path.length === 1){
            // Get property
            const prop = this.db.findRelated(this.db.model(object), [BusinessObject.propertyRel], tag => this.db.name(tag) === path[0]);
            if(prop){
                return this.db.getProperty(object, CloudObject.get(prop), false);
            } else {
                this.logger.error(`Property '${path[0]}' not found`)
                return '';
            }
        } else {
            // Follow relation
            const rel = this.db.findRelated(this.db.model(object), [RelationPrimitive.originModelRel.getInverse()], tag => this.db.name(tag) === path[0]);
            if(rel){
                let rel1 = new transformers.Related(rel, Direction.DESTINATION);
                let rel2 = new transformers.Related(rel, Direction.ORIGIN);

                // Try the relation in both direction or fail if nothing is found
                path.shift();
                if(this.db.getUniqueRelated(object, rel1)){
                    return this.extractProp(this.db.getUniqueRelated(object, rel1), path);
                } else if(this.db.getUniqueRelated(object, rel2)){
                    return this.extractProp(this.db.getUniqueRelated(object, rel2), path);
                } else {
                    this.logger.error(`Relation '${path[0]}' not instantiated`)
                    return '';
                }
            } else {
                this.logger.error(`Relation '${path[0]}' not found`)
                return '';
            }
        }
    }
}

registerBrick('017aafd207a2ca8497b3', ObjectToChartsData);
